import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';

const OccasionCircles = ({ banners, level1Category }) => {
  if (!banners || banners.length === 0) return null;

  return (
    <div className="py-4">
      <h3 className="text-base font-bold text-gray-900 px-4 mb-3">Shop by Category</h3>
      <div className="flex gap-4 overflow-x-auto scrollbar-hide px-4">
        {banners.map((banner) => (
          <Link
            key={banner._id}
            to={`/user/browse/${encodeURIComponent(level1Category)}/${encodeURIComponent(banner.categoryLevel2)}`}
            className="flex-shrink-0 w-[80px] text-center"
          >
            <div className="w-[72px] h-[72px] rounded-2xl overflow-hidden mx-auto bg-gray-100">
              {banner.imageUrl ? (
                <img
                  src={banner.imageUrl}
                  alt={banner.categoryLevel2}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <LayoutGrid className="w-6 h-6 text-gray-300" strokeWidth={1.5} />
                </div>
              )}
            </div>
            <p className="text-[11px] font-medium text-gray-700 text-center mt-1.5 line-clamp-2 leading-tight">
              {banner.categoryLevel2 || banner.title}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OccasionCircles;
